const breakpoints = {
  mobile: '0px',
  tablet: '600px',
  desktop: '960px',
  desktopL: '1280px',
  desktopXL: '1920px'
};
const appTheme = {
  breakpoints,
  media: {
    tablet: `@media (min-width: ${breakpoints.tablet})`,
    desktop: `@media (min-width: ${breakpoints.desktop})`,
    desktopL: `@media (min-width: ${breakpoints.desktopL})`,
    desktopXL: `@media (min-width: ${breakpoints.desktopXL})`
  },
  color: {
    button: {
      disabled: {
        background: '#eaf0f6',
        color: '#b0c1d4'
      },
      primary: {
        activeBackground: '#e66e50',
        background: '#ff7a59',
        hoverBackground: '#ff8f73'
      },
      link: {
        active: '#7fd1de',
        color: '#0091ae',
        hover: '#007a8c'
      }
    },
    formControl: {
      textInput: {
        background: '#f5f8fa',
        border: '#cbd6e2',
        color: '#33475b',
        errorBorder: '#f2545b'
      },
      toggle: {
        boxShadow: {
          color: '#cbd6e2'
        },
        checked: {
          background: '#00a4bd'
        },
        default: {
          background: '#eaf0f6'
        },
        disabled: {
          background: '#f9fbfd',
          color: '#b0c1d4'
        }
      }
    },
    spinner: {
      color: '#33475b'
    }
  },
  typography: {
    fontFamily: `'Lexend Deca', Helvetica, Arial, sans-serif`
  }
};
export default appTheme;